import { getParentPartialUpdateContainer } from './partialUpdateUtils';
import { resolveExecute } from './partialUpdate';

const submitButtonSelectors = [
  'input[type="submit"]',
  'button[type="submit"]',
  'input[type="image"]',
  'button[type="image"]',
  'input[type="button"]',
];

/**
 * Přidá na všechny submit tlačítka v documentu clik listener.
 * Po kliknutí na tlačítko se vyvolá executeSubmit.
 * Všechy tlačítka která jsou uvnitř elementu s třídou nebo mají noPartialUpdate budou ignorovány.
 */
export default (settings) => {
  document.addEventListener('click', (e) => {
    if (!e.defaultPrevented) {
      const submitButton = e.target.closest(submitButtonSelectors.join(','));
      if (submitButton && !submitButton.disabled) {
        const closestForm = submitButton.closest('form');
        const closestNoPartialUpdate = submitButton.closest('.noPartialUpdate');
        const parentPUContainer = getParentPartialUpdateContainer(submitButton);
        if (parentPUContainer && closestForm && closestNoPartialUpdate == null) {
          e.preventDefault();
          resolveExecute(
            submitButton,
            {
              eventName: submitButton.getAttribute('name'),
              ...settings,
            }
          );
        }
      }
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/connectFormsSubmitListeners.js